import React from 'react';
import { useEffect, useState } from 'react';
import axios from 'axios';
import Modal from '../Components/Modal';
import BiddingForm from './BiddingForm';

import { getToken } from '../utils';

const inputObject = {
  amount: '',
  rate: '',
  message: '',
};

function StageBidding({ content }) {
  const [bidData, setBidData] = useState(inputObject);
  //   const [isDisabled, setisDisabled] = useState(false);
  const [isSubmittingBid, setIsSubmittingBid] = useState(false);
  const {
    getDataById,
    handleOpenandCloseModal,
    openModal,
    clickedBidChatUser,
    handleToast,
    // isDisabled,
    // setisDisabled,
    disableBid,
  } = content;
  // const navigate = useNavigate();
  const { token: userToken } = getToken();

  const handleSubmitBid = (e) => {
    e.preventDefault();
    setIsSubmittingBid(true);
  };
  // const userId = getToken()?.user.id;

  //post bid to bid chart
  useEffect(() => {
    if (isSubmittingBid) {
      const submitBid = async () => {
        try {
          const response = await axios.post(
            `${process.env.REACT_APP_BASE_URL}/bid/chat-store`,
            {
              amount: bidData.amount,
              rate: bidData.rate,
              message: bidData.message,
              bid_id: clickedBidChatUser?.id,
            },

            {
              headers: { Authorization: `Bearer ${userToken}` },
            }
          );

          clickedBidChatUser?.chats?.splice(0, 0, response?.data?.chat);
          setBidData(inputObject);
          setIsSubmittingBid(false);

          handleToast('success', 'Bid submited successfully');
          // setisDisabled(true);
          handleOpenandCloseModal('close');
        } catch (error) {
          handleToast('error', 'Failed to submit bid, please try again!');
          setIsSubmittingBid(false);
        }
      };
      submitBid();
    }
  }, [
    userToken,
    clickedBidChatUser?.id,
    isSubmittingBid,
    bidData.amount,
    bidData.rate,
    bidData.message,
    clickedBidChatUser?.chats,
    handleToast,
    handleOpenandCloseModal,
  ]);

  return (
    <article>
      <div className='w-full pb-4 border-hf p-4  rounded-lg relative  bg-p-wh'>
        <div
          className={`w-fit h-fit px-3 py-1 absolute -top-4 left-1/2 transform -translate-x-1/2  shadow-md rounded-full flex justify-center items-center ${
            clickedBidChatUser?.offer_owner_accepted === '1'
              ? 'bg-b-mc text-p-wh'
              : 'bg-orange-500 text-p-wh'
          }`}
        >
          1
        </div>
        <div className='flex flex-row justify-between mt-2 mb-2'>
          <h2 className='font-semibold text-sm'>Place Bid</h2>

          <button
            className='py-1.5 bg-b-mc text-p-wh rounded text-xs w-16 h-fit disabled:bg-p-bk/5 hover:bg-b-mc/75 focus:bg-b-mc/80'
            onClick={() => handleOpenandCloseModal('placeBid')}
            disabled={!!disableBid}
          >
            Bid
          </button>
        </div>
        <div className='text-xs flex flex-col text-p-bk'>
          <h5 className='text-right text-p-bk font-semibold text-[10px] pb-1 border-b-hf'>
            Amount - Rate
          </h5>
          <div className='overflow-y-scroll max-h-20'>
            {clickedBidChatUser?.chats?.map((data, index) => {
              const txnOwner = data?.orginator?.id === data?.user?.id; //checkin trx owner
              const trxType = getDataById?.transaction_type.id; //checking 4transaction type

              return (
                <p
                  key={index}
                  className={`${
                    txnOwner && trxType === 2
                      ? 'text-red-500'
                      : txnOwner && trxType === 1
                      ? 'text-green-500'
                      : txnOwner === false && trxType === 2
                      ? 'text-green-500'
                      : txnOwner === false && trxType === 1
                      ? 'text-red-500'
                      : null
                  } flex flex-row justify-between text-[10px] -mt-[1px] border-t-hf rounded-md`}
                >
                  {txnOwner && trxType === 2
                    ? 'Seller'
                    : txnOwner && trxType === 1
                    ? 'Buyer'
                    : txnOwner === false && trxType === 2
                    ? 'Buyer'
                    : txnOwner === false && trxType === 1
                    ? 'Seller'
                    : null}
                  <span>
                    {(data?.amount * 1)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
                      ' ' +
                      getDataById?.quote_currency?.symbol}{' '}
                    -
                    {' ' +
                      (data?.rate * 1)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
                      ' ' +
                      getDataById?.base_currency?.symbol}
                  </span>
                </p>
              );
            })}
          </div>
        </div>
        <Modal open={openModal === 'placeBid'}>
          <BiddingForm
            content={{
              getDataById,
              handleOpenandCloseModal,
              setBidData,
              bidData,
              isSubmittingBid,
              handleSubmitBid,
            }}
          />
        </Modal>
      </div>
    </article>
  );
}

export default StageBidding;
